import React, { useCallback, useState } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

interface Props {
    id: string;
    label: string;
    checked: boolean;
    onChange: () => void;
}

export const Checkbox: React.FC<Props> = props => {
    const {
        id,
        label,
        checked,
        onChange,
    } = props;

    const [checkedState, setCheckedState] = useState<boolean>(checked);

    const handleChange = useCallback(() => {
        setCheckedState(!checkedState);
        onChange();
    }, [checkedState]);

    return (
        <Form.Group>
            <InputGroup>
                <Form.Check type="checkbox"
                            id={id}
                            custom
                            onChange={handleChange}
                            checked={checkedState}
                            label={label}
                />
            </InputGroup>
        </Form.Group>
    );
};
